const styles = {
  bold: {
    fontWeight: "bold"
  },
  buttonSecond: {
    marginLeft: 30
  },
  buttonBack: {
    marginLeft: 30
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "row"
  },
  city: {
    color: "rgb(153, 153, 153)",
    fontSize: 14
  },
  container: {
    color: "rgb(51, 51, 51)",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: 30
  },
  divider: {
    backgroundColor: "rgb(238, 238, 238)",
    height: 1,
    margin: "20px 0",
    width: "100%"
  },
  price: {
    borderBottom: "solid 1px rgb(238, 238, 238)",
    fontSize: 24,
    fontWeight: 300,
    paddingBottom: 15,
    marginTop: 15
  },
  tab: {
    color: "rgb(50, 118, 177)",
    cursor: "pointer",
    fontSize: 12,
    lineHeight: "20px",
    padding: "5px 10px"
  },
  tabActive: {
    backgroundColor: "rgb(50, 118, 177)",
    color: "white"
  },
  tabContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "row",
    minHeight: 45,
    paddingTop: 15
  },
  tabContent: {
    color: "rgb(51, 51, 51)",
    fontSize: "12"
  },
  title: {
    color: "rgb(51, 51, 51)",
    fontSize: 22,
    fontWeight: 300
  }
};

export default styles;
